<template>
	<div class="no_data">
		<div class="no_pic">
			<img src="@/assets/images/no_data.png" alt="">
		</div>
		<div class="no_wz t-center">
			暂无数据
		</div>
	</div>
</template>

<script>
	export default {
		name: "nodata",
		data() {
			return {

			}
		},
		methods: {

		}
	}
</script>

<style lang="scss">
	.no_data {
		width: 200px;
		margin: 0 auto;
	}

	.no_pic {
		width: 200px;
		height: 175px;
		margin: 30px auto 0;

		img {
			display: block;
		}
	}

	.no_wz {
		text-align: center;
		font-size: 14px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: #B0BAC7;
		padding-bottom: 30px;
	}
</style>